import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Order } from '../../services/exports/Interfaces';
import { DeliveryProvider, ORDER_METHODS } from '../../services/exports/Constants';
import useAppMethods from '../../hooks/utility/useAppMethods';
import moment from 'moment-timezone';
import { isOnSiteMethod } from '../../utils/on-site';

interface Props {
  order: Order;
  className?: string;
}

export default function PickupTimeChangedNotice({ order, className }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Order:PickupTimeChangedNotice' });
  const { formatTime } = useAppMethods();

  const initialTime = order?.fulfillment?.initial_confirmation_time;
  const currentTime = order?.fulfillment?.estimated_pickup_time;
  const isDeliveryWithoutStandaloneProvider =
    order?.method === ORDER_METHODS.DELIVERY && order?.delivery_provider !== DeliveryProvider.Standalone;

  if (!initialTime || !currentTime || isDeliveryWithoutStandaloneProvider || initialTime === currentTime) {
    return null;
  }

  return (
    <div
      className={classnames(
        'flex items-start gap-[10px] rounded-lg border border-brand-primary/30 bg-brand-primary/10 px-[14px] py-[10px]',
        className,
      )}
    >
      <AlertCircle className="w-4 h-4 text-brand-primary shrink-0 mt-[2px]" />
      <div className="text-xs leading-relaxed">
        <p className="text-xs font-semibold text-brand-text-primary">
          {/* A table order is served, not picked up. */}
          {t(isOnSiteMethod(order?.method) ? 'title_on_site' : 'title', { company: order?.company?.name })}
        </p>
        <p className="text-xs text-muted-foreground">
          {t('new_time_label')}:{' '}
          <span className="font-semibold text-brand-text-primary tabular-nums">
            {formatTime(currentTime)} - {formatTime(moment(currentTime).add(10, 'minutes'))}
          </span>
        </p>
      </div>
    </div>
  );
}
